import RouteCalculator from '@/assets/routePlanner/RouteCalculator.js';
import axios from 'axios'

var RoutePlanner = new function(startNetwork, map) {
  //Map var
  this.map = map;
  //Debug tools - Get passed to RouteCalculator class as param
  this.developerMode = {route: false, network: false, osm: false};
  //Predefined network from urlParams
  this.startNetwork = false;
  //Network data - Moved from old Network.js
  this.networkData = [];

  //Route calculator
  this.RouteCalculator = new RouteCalculator(this.developerMode, this.map);

  //Route points
  this.destinationCoords = {
    start: false,
    end: false,
    via: false,
  };

  //Access points
  this.accessPoints = {
    start: false,
    end: false,
    via: false,
  };

  //Route data
  this.routeTypes = {
    //Car networks
    car: {
      type: 'car',
      typeDk: 'Bil',
      selected: true,
      routeMode: 'SETFASTEST',
      routeColor: '#a7172b',
      noActiveNetwork: false,
      basicNetwork: {
        id: 101
      },
      networks: [
        {id: 102, active: false},
        {id: 103, active: false},
        {id: 104, active: false},
        {id: 105, active: false},
        {id: 106, active: false}
      ],
      tempNetworks: [107, 108],
      osmNetwork: 139,
    },
    //Bike networks
    bikeRecommended: {
      type: 'bike',
      typeDk: 'Cykel - Anbefalet rute',
      selected: false,
      routeMode: 'SETFASTEST',
      routeColor: '#00708d',
      noActiveNetwork: false,
      basicNetwork: {
        id: 110
      },
      networks: [
        {id: 111, active: false},
        {id: 112, active: false},
        {id: 113, active: false},
        {id: 114, active: false},
        {id: 115, active: false}
      ],
      tempNetworks: [116, 117],
      osmNetwork: 140
    },
    bikeShortest: {
      type: 'bike',
      typeDk: 'Cykel - Korteste rute',
      selected: false,
      routeMode: 'SETSHORTEST',
      routeColor: '#0096ce',
      noActiveNetwork: false,
      basicNetwork: {
        id: 110
      },
      networks: [
        {id: 111, active: false},
        {id: 112, active: false},
        {id: 113, active: false},
        {id: 114, active: false},
        {id: 115, active: false}
      ],
      tempNetworks: [116, 117],
      osmNetwork: 140
    },
    //Green route subnetwork
    bikeGreen: {
      type: 'bike',
      typeDk: 'Cykel - Grøn rute',
      selected: false,
      routeMode: 'SETFASTEST',
      routeColor: '#00643f',
      noActiveNetwork: false,
      basicNetwork: {
        id: 119
      },
      networks: [
        {id: 120, active: false},
        {id: 121, active: false},
        {id: 122, active: false},
        {id: 123, active: false},
        {id: 124, active: false}
      ],
      tempNetworks: [125, 126],
      osmNetwork: 140
    },
    //Nighttime route subnetwork
    bikeNight: {
      type: 'bike',
      typeDk: 'Cykel - Aften rute',
      selected: false,
      routeMode: 'SETFASTEST',
      routeColor: '#002e5e',
      noActiveNetwork: false,
      basicNetwork: {
        id: 128
      },
      networks: [
        {id: 129, active: false},
        {id: 130, active: false},
        {id: 131, active: false},
        {id: 132, active: false},
        {id: 133, active: false}
      ],
      tempNetworks: [134, 135],
      osmNetwork: 140
    },
    //Pedestrian networks
    pedestrian: {
      type: 'pedestrian',
      typeDk: 'Fodgænger',
      selected: false,
      routeMode: 'SETFASTEST',
      routeColor: '#ffdc00',
      noActiveNetwork: false,
      basicNetwork: {
        id: 137
      },
      networks: [
        {id: 137, active: false}
      ],
      tempNetworks: false,
      osmNetwork: 141
    }
  };

  //Setup basic data etc.
  this.initRoutePlanner = function() {
    //Setup network data for route types
    if(this.developerMode.network) { console.log('List of all networks'); console.log(Networks.networks); console.log('----------------'); }

    this.getNetworkData();

    if(this.destinationCoords['start'] != false ) {
      var options = {direction: 'start', coords: this.startCoords, type: 'coords'};
      this.setDestinationData(options);
    }
    if(this.destinationCoords['end'] != false) {
      var options = {direction: 'end', coords: this.endCoords, type: 'coords'};
      this.setDestinationData(options);
    }
    if(this.destinationCoords['via'] != false) {
      console.log(this.destinationCoords['via']);
      //for(var i in this.viaCoords) {
        var options = {direction: 'via', coords: this.viaCoords, type: 'coords'};
        this.setDestinationData(options);
      //}
    }
  };

  this.getNetworkData = function() {
    axios.get('https://apps.odenserundt.dk/data/networks/new-networks.json')
	  .then(response => {
			//console.log(response);
			for(var i in response.data) {
				for(var k in response.data[i].networks) {
					this.networkData.push({'name': response.data[i].name, 'networkId': response.data[i].networks[k], 'type': response.data[i].type, 'startDate': response.data[i].start_date, 'endDate': response.data[i].end_date});
				}
			}
      this.addNetworksData();
	  })
	  .catch(function (error) {
	    console.log(error);
	  });
  };

  //Add networks data and insert into routeTypes object.
  this.addNetworksData = function() {
    for(var i in this.routeTypes) {
      if(this.developerMode.route) console.log(i, this.routeTypes[i]);

      for(var a in this.routeTypes[i].networks) {
        for(var k in this.networkData) {
          if(this.networkData[k].networkId == this.routeTypes[i].networks[a].id) {
            //Add start and end date for network - Used later for sorting road signs when switching between networks
            this.routeTypes[i].networks[a].startDate = this.networkData[k].startDate;
            this.routeTypes[i].networks[a].endDate = this.networkData[k].endDate;
            //Check if network is active
            this.routeTypes[i].networks[a].active = this.checkIfActive(this.networkData[k]);
            //Check if close to being active
            this.routeTypes[i].networks[a].activeSoon = this.checkIfActiveSoon(this.networkData[k]);
            //Add network name
            this.routeTypes[i].networks[a].name = this.networkData[k].name;
            //Debug
            if(this.developerMode.network) { console.log('Network:', this.routeTypes[i].networks[a].id, 'Active:', this.routeTypes[i].networks[a].active, 'Name:', this.routeTypes[i].networks[a].name);}
          }
        }
      }
    }
  };

  //Create route plan Route
  this.createRoutePlan = function(callback) {
    var selectedRoute;
    //Loop going through data and calculate routes
    for(var i in this.routeTypes) {
      if(this.routeTypes[i].selected) {
        if(this.developerMode.route) console.log('Selected route type:', i);
        selectedRoute = this.routeTypes[i];
        //Use accesspoint coordinates if defined
        var startCoords = this.accessPoints['start'] != false && this.accessPoints['start'][selectedRoute.type] != false ? this.accessPoints['start'][selectedRoute.type] : this.destinationCoords['start'];
        var endCoords = this.accessPoints['end'] != false && this.accessPoints['end'][selectedRoute.type] != false ? this.accessPoints['end'][selectedRoute.type] : this.destinationCoords['end'];
        var viaCoords = this.accessPoints['via'] != false && this.accessPoints['via'][selectedRoute.type] != false ? this.accessPoints['via'][selectedRoute.type] : this.destinationCoords['via'];

        var options = {
          startCoords: startCoords,
          endCoords: endCoords,
          viaCoords: viaCoords,
          network: undefined,
          osmNetwork: selectedRoute.osmNetwork,
          routeMode: selectedRoute.routeMode,
          type: selectedRoute.type
        };

        var result;
        //Next calculate route for active network - Use basis if none is found
        var activeNetwork = selectedRoute.basicNetwork
        var activeNetworkFound = false;
        var soonActiveNetworks = [];
        for(var k in selectedRoute.networks) {
          if(selectedRoute.networks[k].active) {
            activeNetwork = selectedRoute.networks[k];
            activeNetworkFound = true;
          }
          else if(selectedRoute.networks[k].activeSoon) {
            soonActiveNetworks.push(selectedRoute.networks[k]);
          }
        }
        if(activeNetworkFound == false) {
          selectedRoute.noActiveNetwork = true;
        }
        //Check if route is already calculated for these coords on this type
        if(activeNetwork.lastUsedCoords == undefined || activeNetwork.lastUsedCoords.start != options.startCoords || activeNetwork.lastUsedCoords.end != options.endCoords || activeNetwork.lastUsedCoords.via != options.viaCoords) {
          options.network = activeNetwork.id;
          result = this.RouteCalculator.analyzeRoute(options);
          activeNetwork.route = result != 'Error' ? result.data : 'Error';
          activeNetwork.alternateRoute = result != 'Error' ? result.alternateRoute : 'Error';
          if(activeNetwork.alternateRoute !== false && activeNetwork.route != 'Error') {
            activeNetwork.alternateRoute.route = this.RouteCalculator.analyzeRoute(options, true).data;
          }
          //console.log(activeNetwork.route);
          activeNetwork.lastUsedCoords = {start: options.startCoords, end: options.endCoords, via: options.viaCoords};
          //Calculate route on the next network in line - Used to check if route will change. Ignore if pedestrian, since there is only 1 network for them.
          if(selectedRoute.type != 'pedestrian') {
            for(var k in soonActiveNetworks) {
              options.network = soonActiveNetworks[k].id;
              result = this.RouteCalculator.analyzeRoute(options);
              soonActiveNetworks[k].route = result != 'Error' ? result.data : 'Error';
              soonActiveNetworks[k].alternateRoute = result != 'Error' ? result.alternateRoute : 'Error';
              if(soonActiveNetworks[k].alternateRoute !== false && soonActiveNetworks[k].route != 'Error') {
                soonActiveNetworks[k].alternateRoute.route = this.RouteCalculator.analyzeRoute(options, true).data;
              }
            }
          }
        }
      }
    }
    callback(selectedRoute);
  };

  //Check if current time is within network active time
  this.checkIfActive = function(network) {
    var networkActive = false;
    var timeNow = Date.now() / 1000;

    /*console.log('----------------------');
    console.log(network);
    console.log('now:', timeNow/1000);
    console.log('start:', network.startDate/1000);
    console.log('end:', network.endDate/1000);*/

    if(network.startDate < timeNow && network.endDate > timeNow) {
      networkActive = true;
    }

    return networkActive;
  };

  //Check if current time is within network active time
  this.checkIfActiveSoon = function(network) {
    var networkActiveSoon = false;
    var timeNow = Date.now() / 1000;

    /*console.log('----------------------');
    console.log(network);
    console.log('now:', timeNow/1000);
    console.log('start:', network.startDate/1000);
    console.log('end:', network.endDate/1000);*/

    //If startdate of upcomming network is within 28 days from today, set as active soon
    if(network.startDate - timeNow < 2419200 && network.startDate - timeNow > 0) {
      networkActiveSoon = true;
    }

    return networkActiveSoon;
  };

  //Set point
  this.setDestinationData = function(options) {
    //console.log(options);
    if(this.developerMode.route) { console.log(options); }
    /*if(options.direction == 'via') {
      this.destinationCoords[options.direction].push({lat: options.coords.lat, lng: options.coords.lng});
    }
    else {*/
      this.destinationCoords[options.direction] = {lat: options.coords.lat, lng: options.coords.lng};
    //}
    if(options.accessPoints != undefined) {
      this.accessPoints[options.direction] = options.accessPoints;
    }
    else {
      this.accessPoints[options.direction] = false;
    }
    //FitBounds
    //this.map.map.setView([options.coords.lat, options.coords.lng]);
  };

  this.initRoutePlanner();
};

export default RoutePlanner;
